const KEY_STORAGE_KEY = 'resonance.personalAnthropicApiKey.v1';
const ENABLED_STORAGE_KEY = 'resonance.usesPersonalAnthropicApiKey.v1';

function storage(): Storage | null {
  return typeof localStorage === 'undefined' ? null : localStorage;
}

export function readPersonalAnthropicApiKey(): string | null {
  try {
    return storage()?.getItem(KEY_STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function isPersonalAnthropicApiKeyEnabled(): boolean {
  try {
    return Boolean(readPersonalAnthropicApiKey()) && storage()?.getItem(ENABLED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function activePersonalAnthropicApiKey(): string | null {
  return isPersonalAnthropicApiKeyEnabled() ? readPersonalAnthropicApiKey() : null;
}

export function savePersonalAnthropicApiKey(rawValue: string): void {
  const apiKey = rawValue.trim();
  if (!apiKey.startsWith('sk-ant-') || apiKey.length < 20 || apiKey.length > 512 || /\s/.test(apiKey)) {
    throw new Error('Enter a valid Anthropic API key beginning with sk-ant-.');
  }
  const target = storage();
  if (!target) throw new Error('This browser cannot save the API key.');
  target.setItem(KEY_STORAGE_KEY, apiKey);
  target.setItem(ENABLED_STORAGE_KEY, 'true');
}

export function setPersonalAnthropicApiKeyEnabled(enabled: boolean): void {
  const target = storage();
  if (!target) throw new Error('This browser cannot update the API key setting.');
  if (enabled && !readPersonalAnthropicApiKey()) {
    throw new Error('Save a personal Anthropic API key first.');
  }
  target.setItem(ENABLED_STORAGE_KEY, String(enabled));
}

export function removePersonalAnthropicApiKey(): void {
  const target = storage();
  if (!target) return;
  target.removeItem(KEY_STORAGE_KEY);
  target.removeItem(ENABLED_STORAGE_KEY);
}
